import { createContext, useContext } from 'react'

export type SelectionBoxGroupContextValue = {
  name: string
  selectedValue: string
  disabled: boolean
  darkMode: boolean
  onValueChange: (value: string) => void
}

export const SelectionBoxGroupContext =
  createContext<SelectionBoxGroupContextValue | null>(null)

export const useSelectionBoxGroupContext =
  (): SelectionBoxGroupContextValue | null =>
    useContext(SelectionBoxGroupContext)
